import React, { useState, useEffect } from 'react';
import './Dropdown.css';
import { useDetectClickOutside } from 'react-detect-click-outside';

import {CaretDown} from '@phosphor-icons/react'

const Dropdown = (props) => {
    const [enabled, setEnabled] = useState(false)

    const ref = useDetectClickOutside({ onTriggered: () => {setEnabled(false);}});

    useEffect(() => {
        window.addEventListener("scroll", (e) => setEnabled(false));
    }, [setEnabled]);

    function toggleEnabled(state = null) {
        setEnabled(state ?? !enabled);
    }

    return (
        <div className='Dropdown' ref={ref} onMouseEnter={() => toggleEnabled(true)} onMouseLeave={() => toggleEnabled(false)} {...props}>
            <div className='DropdownText' onClick={()=>toggleEnabled()}>
                {props.link == null ? props.title : <a href={props.link}>{props.title}</a>}&nbsp;<div className={`DropdownIndicator ${enabled && 'close'}`}><CaretDown size={15} /></div>
            </div>
            <div className={`DropdownContentContainer ${!enabled && 'hidden'}`}>
                <div className={`DropdownContent ${props.noCorner && "NoCorner"} bg-light shadow`}>
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default Dropdown;